import useTranslation from 'next-translate/useTranslation'
import { useDispatch, useSelector } from 'react-redux'
import {
  EXTERNAL_LOAD_EDIT,
  LOAD_BOARD_EDIT_LOAD,
  MYLOADS_EDIT_LOAD,
  MYTRUCKS_EDIT_TRUCKS,
  TRUCK_BOARD_EDIT_TRUCK
} from 'tennders-stracture/libs/permissions'
import GModal from 'tennders-market/common/components/element/GModal'
import GHref from 'tennders-market/common/components/element/GHref'
import RequiresPermission from 'tennders-auth/components/RequiresPermission'
import { StateType } from 'tennders-common/types/StateType'
import { dispatchEditModal } from 'tennders-common/stores/modal/action'
import useSession from 'tennders-auth/hooks/useSession'
import { useRouter } from 'next/router'

const MEditTransaction = (props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const transaction = useSelector((state:StateType) => state.modal.edit)
  const close = () => dispatch(dispatchEditModal(null))
  const { isBroker } = useSession()
  const { push } = useRouter()

  return transaction
    ? (
      <GModal
        close={close}
        isOpen={!!transaction}
        size={500}
        {...props}
      >
        <div className="tennders-modal-body w-100">
          <div className="d-flex flex-row p-20">
            <h3 className="bold text-center w-100">{t('addEdit:updateTransaction')}</h3>
            <div className="d-flex w-100 justify-around">
              <RequiresPermission
                requiredPermissions={transaction?.matchedLoad?.internalOwner ? [
                  MYLOADS_EDIT_LOAD,
                  LOAD_BOARD_EDIT_LOAD
                ] : (isBroker() ? EXTERNAL_LOAD_EDIT : [])}
              >
                <GHref
                  disabled={transaction?.matchedLoad?.isMarketPlaced}
                  disableHint="Load From MarketPlace"
                  className="btn standard-btn cursor-pointer mt-20 mr-4 has-shadow"
                  onClick={() => {
                    push(`/edit/load/${transaction.matchedLoad?.id}?transaction=true`)
                    close()
                  }}
                >
                  {t('addEdit:editLoad')}
                </GHref>
              </RequiresPermission>
              <RequiresPermission requiredPermissions={[
                TRUCK_BOARD_EDIT_TRUCK,
                MYTRUCKS_EDIT_TRUCKS
              ]}
              >
                <GHref
                  disabled={transaction?.matchedTruck?.isMarketPlaced}
                  disableHint="Truck From MarketPlace"
                  className="btn standard-btn cursor-pointer mt-20 mr-4 has-shadow"
                  onClick={() => {
                    push(`/edit/truck/${transaction.matchedTruck?.id}?transaction=true`)
                    close()
                  }}
                >
                  {t('addEdit:editTruck')}
                </GHref>
              </RequiresPermission>
            </div>
          </div>
        </div>
      </GModal>
    ) : null
}

export default MEditTransaction
